import { render, staticRenderFns } from "./NewInput.vue?vue&type=template&id=25becaf3&scoped=true"
import script from "./NewInput.vue?vue&type=script&lang=js"
export * from "./NewInput.vue?vue&type=script&lang=js"
import style0 from "./NewInput.vue?vue&type=style&index=0&id=25becaf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25becaf3",
  null
  
)

export default component.exports